export const pushEvent = (event, payload = {}) => {
  if (global.dataLayer) {
    global.dataLayer.push({
      ...payload,
      event
    })
  }
}
